class SDG {
  constructor({ id, _id, code, title,url }) {
    this.id = id || _id;
    this.code = code;
    this.title = title;
    this.url=url;
  }
}

export default SDG;
